import { useState } from "react";
import "./TechTips.css";
import ProperlyLoadMotorcycle from "./ProperlyLoadMotorcycle.jsx";
import ProperlyStoreHarley from "./ProperlyStoreHarley.jsx";
import BreakInEngine from "./BreakInEngine.jsx";
import Ethanol101 from "./Ethanol101.jsx";
import E15Fuel from "./E15Fuel.jsx";
import FullService from "./FullService.jsx";
import TireTips from "./TireTips.jsx";
import CoolerWeather from "./CoolerWeather.jsx";
import MSFPreRide from "./MSFPreRide.jsx";

const techTipsTabs = [
  {
    label: "How to Properly Load your Motorcycle",
    content: ProperlyLoadMotorcycle,
  },
  {
    label: "How to Properly Store Your Harley-Davidson",
    content: ProperlyStoreHarley,
  },
  {
    label: "How to Properly Break-In a new/rebuilt Engine",
    content: BreakInEngine,
  },
  {
    label: "Ethanol 101 All about E10 Ethanol Fuel",
    content: Ethanol101,
  },
  {
    label: "E15 fuel and what you should know!",
    content: E15Fuel,
  },
  {
    label: "What is a Full Service?",
    content: FullService,
  },
  {
    label: "Things you should know about tires!",
    content: TireTips,
  },
  {
    label: "Riding In Cooler Weather",
    content: CoolerWeather,
  },
  {
    label: "MSF Pre-Ride Check List",
    content: MSFPreRide,
  },

  // Add more tabs as needed based on the source page
];

// eslint-disable-next-line no-unused-vars
function BatteryCareTips() {
  return (
    <ul>
      <li>Keep battery terminals clean and tight.</li>
      <li>Check fluid levels if not maintenance-free.</li>
      <li>Use a battery tender if storing for long periods.</li>
    </ul>
  );
}

// eslint-disable-next-line no-unused-vars
function WinterStorageTips() {
  return (
    <ul>
      <li>Fill the gas tank and add fuel stabilizer.</li>
      <li>Change the oil before storage.</li>
      <li>Store the bike on a stand to avoid flat spots on tires.</li>
      <li>Remove the battery and keep it charged.</li>
    </ul>
  );
}

// eslint-disable-next-line no-unused-vars
function TroubleshootingTips() {
  return (
    <ul>
      <li>If the bike won’t start, check the kill switch and battery first.</li>
      <li>Listen for unusual noises and investigate promptly.</li>
      <li>Refer to your owner’s manual for error codes and solutions.</li>
    </ul>
  );
}

export default function TechTips() {
  const [activeTab, setActiveTab] = useState(0);
  const ActiveTabContent = techTipsTabs[activeTab].content;
  return (
    <div className="techtips-container">
      <h1 className="techtips-title">Tech Tips</h1>
      <div className="techtips-tabs">
        {techTipsTabs.map((tab, idx) => (
          <button
            key={tab.label}
            className={`techtips-tab${activeTab === idx ? " active" : ""}`}
            onClick={() => setActiveTab(idx)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="techtips-content">
        <ActiveTabContent />
      </div>
    </div>
  );
}
